import React from 'react';
import { Menu, ChevronDown, UserCircle, Icon } from 'lucide-react';
import logo from '../../../../assets/images/rio-claro-logo-colorida.svg';
import * as Icons from 'lucide-react';

const ClientHeader = ({ currentClient, onMenuClick = () => {}, isMobile = false, item }) => {
  const Icon = Icons[item?.icon] || Icons.UserCircle;

  return (
    <header className="w-full bg-tealLight px-4 sm:px-6 py-3 h-20 flex items-center justify-between sticky top-0 z-30">
      <div className="flex items-center gap-3">
        {isMobile && (
          <button onClick={onMenuClick} className="p-2 -ml-2 rounded-md hover:bg-blueDark-100" aria-label="Abrir menu">
            <Menu className="w-6 h-6 text-white" />
          </button>
        )}
        <Icon className="h-8 hidden sm:block text-blueDark" size={24} strokeWidth={1.5} />
        <h1 className="text-2xl font-semibold text-white">{item?.label}</h1>
      </div>

      <div className="flex items-center gap-3 text-blueDark">
        <div className="relative w-10 h-10 bg-white rounded-full flex items-center justify-center">
          <button className="p-2 rounded-full hover:bg-blueDark-100" aria-label="Notificações">
            <Icons.Bell className="text-blueDarker" strokeWidth={1.5} size={24} />
          </button>
          {/* <span className="absolute top-2 right-3 w-2 h-2 border-2 border-redHighlight bg-redHighlight rounded-full"></span> */}
        </div>
      </div>
    </header>
  );
};

export default ClientHeader;
